// src/ui/RelativeTime.tsx (T1): a <time> that reads "12 min ago" (or "1:15 PM" in `short` mode) and keeps itself
// current once a minute. The full date and time is the tooltip. Times render in the tenant zone (lib/format).
import { useEffect, useState } from "preact/hooks";
import { formatDateTime, relativeTime, shortWhen } from "../lib/format";

export function RelativeTime(props: { iso: string; mode?: "relative" | "short"; class?: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 60_000);
    return () => window.clearInterval(t);
  }, []);
  const text = props.mode === "short" ? shortWhen(props.iso, now) : relativeTime(props.iso, now);
  return (
    <time class={props.class} dateTime={props.iso} title={formatDateTime(props.iso, now)}>
      {text}
    </time>
  );
}
